import store from "../store";
import Constants from "../config/constants";
import { serviceFetchEzuppBlogs } from "../services/EzuppBlog.service";

// Rows returned per request by the backend list API (Constants.DEFAULT_LIST_LENGTH there).
const SERVER_PAGE_SIZE = 200;

export const FETCH_INIT = "FETCH_INIT_EZUPP_BLOGS";
export const FETCHED = "FETCHED_EZUPP_BLOGS";
export const FETCHED_FAIL = "FETCHED_FAIL_EZUPP_BLOGS";
export const SET_SORTING = "SET_SORTING_EZUPP_BLOGS";
export const SET_FILTER = "SET_FILTER_EZUPP_BLOGS";
export const CHANGE_PAGE = "CHANGE_PAGE_EZUPP_BLOGS";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_EZUPP_BLOGS";
export const UPDATE_DATA = "UPDATE_EZUPP_BLOGS";
export const DELETE_ITEM = "DELETE_ITEM_EZUPP_BLOGS";

export function actionFetchEzuppBlogs(index = 1, sorting = {}, filter = {}) {
  const request = serviceFetchEzuppBlogs({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data?.data || [], page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index === 1) {
          dispatch({ type: CHANGE_PAGE, payload: 0 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionUpdateEzuppBlog(data) {
  return { type: UPDATE_DATA, payload: data };
}

export function actionDeleteEzuppBlog(id) {
  return { type: DELETE_ITEM, payload: id };
}

export function actionSetPageEzuppBlogs(page) {
  const stateData = store.getState().ezuppBlogs;
  const { all, sorting_data: sortingData, query, query_data: queryData, serverPage } = stateData;
  // Only fetch the next server page if the last one came back full.
  const lastServerPageFull = all.length >= serverPage * SERVER_PAGE_SIZE;
  if (lastServerPageFull && all.length <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(actionFetchEzuppBlogs(serverPage + 1, sortingData, { query, query_data: queryData }));
  }
  return { type: CHANGE_PAGE, payload: page };
}
